export default __webpack_public_path__ + "static/2025-img-articolo-febbraio2-0c2f16bf0e3bc58c7db1ff64ea7d4b6f.jpg";